import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-buscador",
  templateUrl: "./buscador.component.html",
  styleUrls: ["./buscador.component.css"],
})
export class BuscadorComponent implements OnChanges, OnDestroy {
  // ===========================
  // ENTRADAS (INPUT)
  // ===========================
  @Input() placeholder = "Buscar...";
  @Input() valor = "";
  @Input() debounceTime = 300;
  @Input() autoFocus = false;

  // ===========================
  // SALIDAS (OUTPUT)
  // ===========================
  // Permite two-way binding: [(valor)]="texto"
  @Output() valorChange = new EventEmitter<string>();

  // Emite el texto ya "debounceado" (listo para filtrar)
  @Output() busqueda = new EventEmitter<string>();

  // Se emite cuando el usuario limpia la búsqueda con el botón "x"
  @Output() limpiado = new EventEmitter<void>();

  // ===========================
  // ESTADO INTERNO
  // ===========================
  private temporizador: ReturnType<typeof setTimeout> | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    // Si el padre resetea "valor" desde afuera (ej: limpiar filtros),
    // no hay lógica extra que hacer aquí, Angular ya actualiza el input
    // vía [ngModel]="valor" en el template.
  }

  ngOnDestroy(): void {
    if (this.temporizador) {
      clearTimeout(this.temporizador);
    }
  }

  //=========================================
  // BUSCADOR
  //=========================================

  onInput(texto: string): void {
    this.valor = texto;
    this.valorChange.emit(this.valor);

    if (this.temporizador) {
      clearTimeout(this.temporizador);
    }

    this.temporizador = setTimeout(() => {
      this.busqueda.emit(this.valor.trim());
    }, this.debounceTime);
  }

  limpiar(): void {
    if (this.temporizador) {
      clearTimeout(this.temporizador);
    }

    this.valor = "";
    this.valorChange.emit(this.valor);
    this.busqueda.emit("");
    this.limpiado.emit();
  }
}
